import { Routes } from '@angular/router'
import { canActivate } from './core/handler/auth.guard'

export const routes: Routes = [
  { path: '', redirectTo: 'shell', pathMatch: 'full' },
  {
    path: 'register',
    loadComponent: () => import('@cr-driver/register/register.component').then((m) => m.RegisterComponent),
    data: { breadcrumb: 'NAV.REGISTER' },
  },
  { path: 'driver-registration-callback', redirectTo: 'login' },
  {
    path: 'login',
    loadComponent: () => import('@cr-driver/login/login.component').then((m) => m.LoginComponent),
    data: { breadcrumb: 'NAV.LOGIN' },
  },
  {
    path: 'logout',
    loadComponent: () => import('@cr-driver/logout/logout.component').then((m) => m.LogoutComponent),
    data: { breadcrumb: 'NAV.LOGOUT' },
  },
  {
    path: 'shell',
    loadComponent: () => import('@cr-driver/initializer/initializer.component').then((m) => m.InitializerComponent),
    canActivate: [canActivate],
    data: { breadcrumb: 'NAV.INITIALIZER' },
  },
  {
    path: 'sso',
    loadComponent: () => import('@cr-driver/sso/sso.component').then((m) => m.SsoComponent),
    data: { breadcrumb: 'NAV.LOGIN' },
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('@cr-driver/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
    data: { breadcrumb: 'NAV.FORGOT_PASSWORD' },
  },
  {
    path: 'reset-password',
    loadComponent: () => import('@cr-driver/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
    data: { breadcrumb: 'NAV.RESET_PASSWORD' },
  },
  /* This must be defined before the other driver stuff in order to exclude it from the auth guard*/
  {
    path: 'driver/configure/register',
    loadComponent: () =>
      import('@cr-driver/onboarding/register/wallbox-registration/gateway-redirect/gateway-redirect.component').then((m) => m.GatewayRedirectComponent),
  },
  {
    path: 'driver',
    canActivate: [canActivate],
    children: [
      { path: '', redirectTo: 'charges', pathMatch: 'full' },
      {
        path: 'charges',
        loadComponent: () => import('@cr-driver/driver/charges/charges.component').then((m) => m.ChargesComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.CHARGES' },
      },
      {
        path: 'accounting',
        loadComponent: () => import('@cr-driver/driver/accounting/driver-accounting.component').then((m) => m.DriverAccountingComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.ACCOUNTING' },
      },
      {
        path: 'mileage',
        loadComponent: () => import('@cr-driver/driver/mileage/driver-mileage.component').then((m) => m.DriverMileageComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.MILEAGE' },
      },
      {
        path: 'wallbox',
        loadComponent: () => import('@cr-driver/driver/my-wallbox/my-wallbox.component').then((m) => m.MyWallboxComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.WALLBOX' },
      },
      {
        path: 'manual/:id',
        loadComponent: () => import('@cr-driver/driver/manual/manual.component').then((m) => m.ManualComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.MANUAL' },
      },
      {
        path: 'settings',
        children: [
          {
            path: '',
            loadComponent: () => import('@cr-driver/driver/settings/driver-settings.component').then((m) => m.DriverSettingsComponent),
            canActivate: [canActivate],
            data: { breadcrumb: 'NAV.SETTINGS' },
          },
          {
            path: 'gateway',
            loadComponent: () => import('@cr-driver/driver/settings/gateway-settings/gateway-settings.component').then((m) => m.GatewaySettingsComponent),
            canActivate: [canActivate],
            data: { breadcrumb: 'NAV.SETTINGS_GATEWAY' },
          },
          {
            path: 'accounting',
            loadComponent: () =>
              import('@cr-driver/driver/settings/account-details-settings/account-details-settings.component').then((m) => m.AccountDetailsSettingsComponent),
            canActivate: [canActivate],
            data: { breadcrumb: 'NAV.SETTINGS_ACCOUNTING' },
          },
          {
            path: 'contract',
            loadComponent: () =>
              import('@cr-driver/driver/settings/energy-contract-settings/energy-contract-settings.component').then((m) => m.EnergyContractSettingsComponent),
            canActivate: [canActivate],
            data: { breadcrumb: 'NAV.SETTINGS_CONTRACT' },
          },
          {
            path: 'rfid',
            loadComponent: () => import('@cr-driver/driver/settings/rfid-settings/rfid-settings.component').then((m) => m.RFIDSettingsComponent),
            canActivate: [canActivate],
            data: { breadcrumb: 'NAV.SETTINGS_RFID' },
          },
          {
            path: 'backend-provider',
            loadComponent: () =>
              import('@cr-driver/driver/settings/backend-provider/backend-provider-settings.component').then((m) => m.BackendProviderSettingsComponent),
            canActivate: [canActivate],
            data: { breadcrumb: 'NAV.SETTINGS_RFID' },
          },
          {
            path: 'auto-charge-assign',
            loadComponent: () => import('@cr-driver/driver/settings/auto-charge-assign/auto-charge-assign.component').then((m) => m.AutoChargeAssignComponent),
            canActivate: [canActivate],
            data: { breadcrumb: 'NAV.SETTINGS_AUTO_CHARGE_ASSIGNMENT' },
          },
        ],
      },
    ],
  },
  {
    path: 'onboarding',
    loadComponent: () => import('@cr-driver/onboarding/onboarding.component').then((m) => m.OnboardingComponent),
    canActivate: [canActivate],
    children: [
      {
        path: 'prerequisites',
        loadComponent: () => import('@cr-driver/onboarding/prerequisites/prerequisites.component').then((m) => m.PrerequisitesComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.ONBOARDING' },
      },
      {
        path: 'no-wallbox',
        loadComponent: () => import('@cr-driver/onboarding/prerequisites/no-wallbox/no-wallbox.component').then((m) => m.NoWallboxComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.ONBOARDING_NO_WALLBOX' },
      },
      {
        path: 'register',
        loadComponent: () => import('@cr-driver/onboarding/register/onboarding-register.component').then((m) => m.OnboardingRegisterComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.ONBOARDING_REGISTER' },
      },
      {
        path: 'order',
        loadComponent: () => import('@cr-driver/onboarding/order-state/order-state.component').then((m) => m.OrderStateComponent),
        canActivate: [canActivate],
        data: { breadcrumb: 'NAV.ONBOARDING_ORDER_STATE' },
      },
    ],
  },
]

/*
@Berry
 Hier sind Links die wie bei uns selbst nutzen (z.B. in den Emails die wir an die Fahrer schicken, oder von Keycloak aus etc.). Die sollten wir nach Möglichkeit nicht ändern, vor allem das /register
app.charge-repay.io/
app.charge-repay.io/driver (können wir ändern, ältere mails verlieren aber gültigkeit/funktion)
app.charge-repay.io/driver/mileage
app.charge-repay.io/register
app.charge-repay.io/forgot-password
 */
